module.exports = __webpack_public_path__ + "img/16581275_L.ea064e13.png";